import { Link } from "react-router-dom";
import { Text } from "@mantine/core";
import styles from "./styles/LatestPodcasts.module.css";
import { getPodcastImage, ImageSizes } from "@/core/helpers";

export function PopularPodcasts({ podcasts }: { podcasts: Podcast[] | undefined }) {
    if (!podcasts) {
        return null;
    }
    return (
        <ul className={styles.list}>
            {podcasts.map((podcast) => (
                <li key={`popular-podcast-${podcast.id}`}>
                    <Link className={styles.row} to={`/podd/${podcast.slug}`}>
                        <img
                            alt=""
                            height={ImageSizes.Thumb}
                            loading="lazy"
                            src={getPodcastImage(podcast, ImageSizes.Thumb)}
                            width={ImageSizes.Thumb}
                        />
                        <span className={styles.text}>
                            <Text fw={600} lineClamp={1}>
                                {podcast.name}
                            </Text>
                            <Text c="dimmed" lineClamp={1} size="sm">
                                {podcast.author.name}
                            </Text>
                        </span>
                    </Link>
                </li>
            ))}
        </ul>
    );
}
